import { Link, useLocation } from "react-router-dom";
import { Scale, LayoutDashboard, BarChart3, FileText } from "lucide-react";
import { cn } from "@/lib/utils";

const items = [
  { to: "/app", label: "Matters", icon: LayoutDashboard, id: "nav-matters" },
  { to: "/forms", label: "Consumer guidance", icon: FileText, id: "nav-forms" },
  { to: "/analytics", label: "Insights", icon: BarChart3, id: "nav-analytics" },
];

export const Nav = () => {
  const loc = useLocation();
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-stone-50/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
          <span className="font-serif text-2xl font-semibold tracking-tight text-slate-900">AI Consumer Champion</span>
        </Link>
        <nav className="flex items-center gap-1">
          {items.map((it) => {
            const active = loc.pathname.startsWith(it.to);
            const Icon = it.icon;
            return (
              <Link
                key={it.to}
                to={it.to}
                data-testid={it.id}
                className={cn(
                  "flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                  active ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"
                )}
              >
                <Icon className="h-4 w-4" /> <span className="hidden sm:inline">{it.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
};
